import { render } from "./commercialScreen.vue?vue&type=template&id=0aefb848"
import script from "./commercialScreen.vue?vue&type=script&lang=js"
export * from "./commercialScreen.vue?vue&type=script&lang=js"

import "./commercialScreen.vue?vue&type=style&index=0&id=0aefb848&lang=css"

import exportComponent from "/home/quantum/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__